import { Injectable } from '@angular/core';
import { Http, RequestOptions, Headers } from '@angular/http';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/catch';
import 'rxjs/add/observable/throw';
import { environment } from '../../environments/environment';

@Injectable()
export class AzureStorageService {
    private baseUrl = environment.urlAPI || 'http://localhost:3000';

    constructor(private http: Http) {}

    enviarArquivo(ref: string, nomeArquivo: string, arquivo: File): any {

        const formData = new FormData();
        formData.append('file', arquivo);
        formData.append('ref', ref);
        formData.append('nomeArquivo', nomeArquivo);

        // Variável para armazenar a URL após upload
        let downloadURL = '';

        // Simula o comportamento completo do Firebase UploadTask
        const uploadTask = {
            snapshot: {
                ref: {
                    getDownloadURL: () => {
                        return new Promise((resolve, reject) => {
                            if (downloadURL) {
                                // Se já temos a URL, retorna ela
                                resolve(downloadURL);
                            } else {
                                // Se não, faz o upload
                                this.http.post(`${this.baseUrl}/azure-storage/upload`, formData)
                                    .map(response => response.json())
                                    .subscribe(
                                        result => {
                                            if (result.type) {
                                                // console.info(`✅ Upload concluído: ${result.data.url}`);
                                                downloadURL = result.data.url; // Armazena a URL
                                                resolve(result.data.url);
                                            } else {
                                                console.error(`❌ Erro no upload: ${result.data}`);
                                                reject(new Error(result.data));
                                            }
                                        },
                                        error => {
                                            console.error(`❌ Erro HTTP no upload:`);
                                            reject(error);
                                        }
                                    );
                            }
                        });
                    }
                }
            },
            
            on: (
                event: string,
                onProgress?: (snapshot: any) => void,
                onError?: (error: any) => void,
                onComplete?: () => void
            ) => {
                if (event === 'state_changed') {
                    // Simula progresso imediatamente
                    if (onProgress) {
                        setTimeout(() => {
                            onProgress({
                                bytesTransferred: arquivo.size * 0.5,
                                totalBytes: arquivo.size,
                                state: 'running'
                            });
                        }, 100);
                    }

                    // Executa o upload
                    this.http.post(`${this.baseUrl}/azure-storage/upload`, formData)
                        .map(response => response.json())
                        .subscribe(
                            result => {
                                if (result.type) {
                                    // console.info(`✅ Upload concluído: ${result.data.url}`);
                                    
                                    // Armazena a URL para uso posterior
                                    downloadURL = result.data.url;
                                    
                                    // Simula progresso completo
                                    if (onProgress) {
                                        onProgress({
                                            bytesTransferred: arquivo.size,
                                            totalBytes: arquivo.size,
                                            state: 'success'
                                        });
                                    }
                                    
                                    // Chama callback de conclusão
                                    if (onComplete) {
                                        onComplete();
                                    }
                                } else {
                                    console.error(`❌ Erro no upload: ${result.data}`);
                                    if (onError) {
                                        onError(new Error(result.data));
                                    }
                                }
                            },
                            error => {
                                console.error(`❌ Erro HTTP no upload:`);
                                if (onError) {
                                    onError(error);
                                }
                            }
                        );
                }
            },

            then: (onSuccess: (result: any) => void, onError?: (error: any) => void) => {
                this.http.post(`${this.baseUrl}/azure-storage/upload`, formData)
                    .map(response => response.json())
                    .subscribe(
                        result => {
                            if (result.type) {
                                console.info(`✅ Upload concluído: ${result.data.url}`);
                                downloadURL = result.data.url; // Armazena a URL
                                onSuccess({
                                    downloadURL: result.data.url,
                                    ref: `${ref}/${nomeArquivo}`,
                                    metadata: {
                                        name: nomeArquivo,
                                        fullPath: `${ref}/${nomeArquivo}`
                                    }
                                });
                            } else {
                                console.error(`❌ Erro no upload: ${result.data}`);
                                if (onError) onError(new Error(result.data));
                            }
                        },
                        error => {
                            console.error(`❌ Erro HTTP no upload:`);
                            if (onError) onError(error);
                        }
                    );
            },

            catch: (onError: (error: any) => void) => {
                return uploadTask.then(() => {}, onError);
            }
        };

        return uploadTask;
    }

    removerArquivo(ref: string): Promise<any> {
        return new Promise((resolve, reject) => {
            console.info(`🗑️ Removendo arquivo do Azure: ${ref}`);

            const headers = new Headers({ 'Content-Type': 'application/json' });
            const options = new RequestOptions({ headers: headers });
            const body = { ref: ref };

            this.http.delete(`${this.baseUrl}/azure-storage/remove`, new RequestOptions({
                headers: headers,
                body: JSON.stringify(body)
            }))
            .map(response => response.json())
            .subscribe(
                result => {
                    if (result.type) {
                        console.info(`✅ Arquivo removido com sucesso`);
                        resolve(result.data);
                    } else {
                        console.error(`❌ Erro na remoção: ${result.data}`);
                        reject(new Error(result.data));
                    }
                },
                error => {
                    console.error(`❌ Erro HTTP na remoção:`);
                    reject(error);
                }
            );
        });
    }
}


// WEBPACK FOOTER //
// /app/src/app/services/azure-storage.service.ts